
import { mapState } from "vuex";
import ModalForm from "../ModalForm.vue";

export default {
  computed: {
    ...mapState("books", {
      books: (state) => state.books.data,
    }),
  },
  methods: {
    openForm(book) {
      this.$modal.open({
        id: "ModalForm",
        component: ModalForm,
        data: {
          props: {
            book,
          },
        },
      });
    },
  },
};
